import { CKEditor } from '@ckeditor/ckeditor5-react';
import { FormItemProps } from 'antd';
import { EventInfo } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { useEffect, useState } from 'react';
import './ck-editor.css';
import HeadlessEditor from './headless';
import { EditorToolbar } from './toolbar';
import { AntFormItem } from '@/common/ant-components/AntFormItem';

interface CkEditorBaseProps {
  value?: string;
  disabled?: boolean;
  setEditor: (editor: any) => void;
  onChange?: (data: string) => void;
  onBlur?: (data: string) => void;
  hideBorder?: boolean;
}
export const CkEditorBase: React.FC<CkEditorBaseProps> = (props) => {
  const {
    onChange,
    onBlur,
    setEditor,
    value,
    hideBorder = false,
    ...rest
  } = props;
  const handleChange = (_: EventInfo, editor: HeadlessEditor) => {
    const data = editor.getData();
    onChange && onChange(data);
  };

  const handleBlur = (_: EventInfo, editor: HeadlessEditor) => {
    const data = editor.getData();
    onBlur && onBlur(data);
  };

  return (
    <div
      className={` ${!hideBorder && 'tw-border-[#ccced1] dark:tw-border-[#424242] tw-border-[1px]'}`}
    >
      <CKEditor
        onReady={setEditor}
        editor={HeadlessEditor}
        data={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...rest}
      />
    </div>
  );
};

interface CustomCKEditorProps {
  disabled?: boolean;
  value?: string;
  onChange?: (data: string) => void;
  onBlur?: (data: string) => void;
  height?: string;
  formProps?: FormItemProps;
}

export const CustomCKEditor: React.FC<CustomCKEditorProps> = (props) => {
  const { height = '150px', formProps = {}, ...rest } = props;
  const { label, ...restFormProps } = formProps;

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [editor, setEditor] = useState<HeadlessEditor | null>(null);

  const toggleFullScreen = () => setIsFullScreen(!isFullScreen);

  useEffect(() => {
    if (editor) {
      editor.editing.view.change((writer) => {
        writer.setStyle(
          'height',
          isFullScreen ? 'calc(100vh - 40px)' : height,
          editor.editing.view.document.getRoot()!,
        );
      });
    }
  }, [editor, height, isFullScreen]);

  return (
    <AntFormItem label={label} required={Boolean(restFormProps?.rules?.length)}>
      <div
        className={
          isFullScreen
            ? 'tw-fixed tw-left-0 tw-top-0 tw-w-[100%] tw-h-[100%] tw-z-[1000] tw-bg-white'
            : ''
        }
      >
        <div className="editor-container editor-container_document-editor">
          <div className="editor-container__toolbar"></div>
          <div className="editor-container__editor-wrapper">
            <div className="editor-container__editor">
              <div>
                <>
                  <EditorToolbar
                    editor={editor}
                    onFullScreen={toggleFullScreen}
                    isFullScreen={isFullScreen}
                  />
                  <AntFormItem {...restFormProps}>
                    <CkEditorBase setEditor={setEditor} {...rest} />
                  </AntFormItem>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AntFormItem>
  );
};
